<script>
import { defineComponent, ref } from 'vue'
import { Grid as VanGrid, GridItem as VanGridItem, Button as VanButton, showToast } from 'vant'
import { ConfigProvider as VanConfigProvider } from 'vant'

import GuinnessTips from './components/Tips.vue'
import TimeCounter from './components/TimeCounter.vue'
import { guinnessChallenge } from '@/api/2023/index.js'

export default defineComponent({
  components: {
    VanGrid,
    VanGridItem,
    VanButton,
    GuinnessTips,
    TimeCounter,
    VanConfigProvider
  },

  setup() {
    const IS_H5 = /Android|webOS|iPhone|iPad|IEMobile|Opera Mini/i.test(navigator.userAgent)
    const grid_count = IS_H5 ? 2 : 4
    const margin_page = IS_H5 ? '10%' : '20%'
    const image_header = IS_H5
      ? 'https://p1.qhimg.com/t01ebabb33562940b15.jpg'
      : 'https://p2.qhimg.com/t01dc85bd84b788d604.png'

    const playRef = ref(null)
    const joinPerthons = ref(null)
    const subItems = ref([])
    var listData = []
    const clickPlay = () => {
      if (playRef.value) {
        if (playRef.value.paused) {
          playRef.value.play()
        } else {
          playRef.value.pause()
        }
      }
    }
    const clickJoin = () => {
      if (IS_H5) {
        showToast('请前往PC端参与！')
      } else window.open('https://isc.360.com/2021/uploadvideo.html', '_blank')
    }
    const clickItem = (vid) => {
      window.open('https://isc.360.com/2020/detail.html?vid=' + vid, '_blank')
    }
    const clickLoadMore = () => {
      addItem(true)
    }

    const themeVars = {
      fontSizeXs: '0.5rem',
      fontSizeSm: '0.75rem',
      fontSizeMd: '1rem',
      fontSizeLg: '1.5rem',
      fontSizeXl: '2rem',
      lineHeightXs: '0.625rem',
      lineHeightSm: '0.75rem',
      lineHeightMd: '0.825rem',
      lineHeightLg: '1.5rem',
      lineHeightXl: '2rem'
    }
    const addItem = function (isClick = false) {
      let currentLen =
        listData.length - subItems.value.length > 12 ? 12 : listData.length - subItems.value.length
      let addoneTime = listData.slice(subItems.value.length, subItems.value.length + currentLen)
      if (isClick && addoneTime.length == 0) {
        showToast('没有更多数据')
      } else addoneTime.map((item) => subItems.value.push(item))
    }
    const initData = function (data) {
      if (data.errno == 0) {
        joinPerthons.value = data.data.num
        listData = data.data.list
        addItem()
      }
    }
    const guinness = function () {
      guinnessChallenge()
        .then((res) => {
          initData(res.data)
        })
        .catch((e) => {
          console.log('cnn--', e)
        })
    }
    guinness()

    return {
      themeVars,
      playRef,
      clickPlay,
      clickJoin,
      clickItem,
      joinPerthons,
      subItems,
      clickLoadMore,
      grid_count,
      IS_H5,
      margin_page,
      image_header
    }
  }
})
</script>

<template>
  <van-config-provider :theme-vars="themeVars">
    <div class="guinness">
      <div class="guinnessHeader">
        <img class="guinnessHeaderB" :src="image_header" />
        <img
          :class="{ guinnessHeaderImageHolder: !IS_H5, guinnessHeaderImageHolderH5: IS_H5 }"
          src="https://p4.qhimg.com/t012790ef7cf1bfec41.png"
        />
        <time-counter :class="{ guinnessHeaderT: !IS_H5, guinnessHeaderTH5: IS_H5 }" />
      </div>
      <div class="guinnessSub">
        <guinness-tips
          title="活动介绍"
          msg="互联网安全大会（简称ISC）是亚太地区历史悠久、规格高、辐射广、影响力深远的全球性安全峰会。ISC 2023第十一届互联网安全大会将于8月9日-10日在北京国家会议中心盛大开幕，全球议题征集正在进行中。ISC将秉持多模态、多场景、国际化、智能化、共享化的理念，打造全球首个AI数字安全峰会。

6月30日12:30-13:30，ISC将邀请全球安全从业者写下关注的前沿议题，向议题最多的行业顶会荣誉发起冲击，力求打破圈层壁垒，汇聚更多安全力量，共同创造专属于数字安全的吉尼斯世界纪录荣誉！"
        ></guinness-tips>
        <guinness-tips
          title="活动安排"
          msg="活动时间：6月30日 12:30-13:30
活动对象：安全决策者、专家学者、行业领袖、安全从业者以及所有关心ISC的朋友均可参加。
挑战形式：写下对ISC 2023第十一届互联网安全大会议题的想法与期待，并用视频记录下这个过程，在规定时间内上传至ISC平台。
可以使用任意手写工具（如：钢笔、铅笔或马克笔等），写在任意空白纸张上（如：便签纸、信纸、A4纸等）。
书写内容：【ISC 2023 我关注：_______】"
        ></guinness-tips>

        <div :class="{ guinnessSubRow: !IS_H5, guinnessSubRowH5: IS_H5 }">
          <div :class="{ guinnessSubRowV: !IS_H5, guinnessSubRowH5V: IS_H5 }">
            <guinness-tips title="视频示例"></guinness-tips>
            <video
              ref="playRef"
              @click="clickPlay"
              src="http://isc.360kan.com/vod-isc-vod-101240-beijing/TL93c512c59f121c29447f6fb136ece4ed.mp4"
              :class="{ guinnessSubRowVPlay: !IS_H5, guinnessSubRowH5VPlay: IS_H5 }"
              poster="https://p2.qhimg.com/t01424b32fbe3377344.png"
              controls
            ></video>
          </div>
          <guinness-tips
            :class="{ guinnessSubRowIn: !IS_H5, guinnessSubRowH5In: IS_H5 }"
            title="参与规则"
            msg="1. 参与者须登陆ISC账号，并在6月30日12:30-13:30期间完成视频上传。
2. 每个上传的视频必须清楚看到参与者手写便签，必须包括人的上半身、胳膊或手、手写工具和手写便签。
3. 手写之前，视频中的人必须在镜头前展示空白纸张，证明纸上没有写好的信息。
4. 参与者必须在视频中展示写好的手写便签，便签内容必须清晰可读。
5. 每位参与者只能上传一个视频，视频中的人也只能出现一次。（视频时长不限)
6. 请在PC端上传视频。"
            msgred="7. 活动开启前您可以通过上传视频参与ISC 2023全球议题征集活动。仅在6月30日12:30-13:30期间上传的视频将被计入本次挑战活动有效参与数量。"
          ></guinness-tips>
        </div>
        <van-button class="guinnessSubBtn" round type="primary" @click="clickJoin"
          >立即参与</van-button
        >
        <div class="guinnessJoin">
          <span class="guinnessJoinB">挑战进行时，已有 </span>
          <span class="guinnessJoinR">{{ joinPerthons }}</span>
          <span class="guinnessJoinB"> 人完成上传</span>
        </div>
        <van-grid :column-num="grid_count" :gutter="0" :border="false" :clickable="true">
          <van-grid-item v-for="value in subItems" :key="value">
            <div
              :class="{ guinnessGridItem: !IS_H5, guinnessGridItemH5: IS_H5 }"
              @click="clickItem(value.id)"
            >
              <img
                :class="{ guinnessGridItemImg: !IS_H5, guinnessGridItemH5Img: IS_H5 }"
                :src="value.img"
                alt=""
              />
              <span :class="{ guinnessGridItemT: !IS_H5, guinnessGridItemH5T: IS_H5 }"
                >@{{ value.user }}</span
              >
              <!-- <span class="guinnessGridItemS">@测试</span> -->
            </div>
          </van-grid-item>
        </van-grid>
        <van-button
          class="guinnessBtn"
          type="primary"
          icon="https://p4.qhimg.com/t01a413139e869aaac9.png"
          icon-position="right"
          @click="clickLoadMore"
          >加载更多</van-button
        >
      </div>
    </div>
  </van-config-provider>
</template>

<style>
.van-icon__image {
  width: 0.8125rem !important;
  height: 0.8125rem !important;
}
</style>
<style lang="scss" scoped>
.van-button--primary {
  border: 0;
}
@font-face {
  font-family: 'MicrosoftYaHei';
  src: url('@/fontFamily/MicrosoftYaHei.ttf');
}
@font-face {
  font-family: 'TypeRegular';
  src: url('@/fontFamily/360shouhuType-Regular.otf');
}
.guinness {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  &Header {
    display: flex;
    position: relative;
    width: 100vw;
    // min-height: 35.4vw;
    justify-content: center;
    align-content: center;
    text-align: center;
    &B {
      object-fit: fill;
      max-width: 100%;
    }
    &ImageHolder {
      position: absolute;
      bottom: 4.25rem;
      width: 22.5rem;
      height: 5.9375rem;
    }
    &T {
      position: absolute;
      bottom: 4.25rem;
      width: 26.5rem;
      height: 5.9375rem;
    }
    &ImageHolderH5 {
      position: absolute;
      bottom: 2.25rem;
      width: 22.5rem;
      height: 5.9375rem;
      // transform: scale(0.7);
    }
    &TH5 {
      position: absolute;
      bottom: 2.25rem;
      width: 26.5rem;
      height: 5.9375rem;
      // transform: scale(0.7);
    }
  }
  &Sub {
    display: flex;
    flex-direction: column;
    padding-left: v-bind(margin_page);
    padding-right: v-bind(margin_page);
    text-align: center;
    align-items: center;
    &RowH5 {
      display: flex;
      flex-direction: column;
      &In {
        flex: 1;
      }
      &V {
        flex: 1;
        display: flex;
        flex-direction: column;
        width: 80vw;
        padding-right: 5%;
        &Play {
          width: 80vw;
          height: 45vw;
          margin-top: 1.25rem;
        }
      }
    }

    &Row {
      display: flex;
      flex-direction: row;
      &In {
        flex: 1;
      }
      &V {
        flex: 1;
        display: flex;
        flex-direction: column;
        width: 23.75vw;
        padding-right: 5%;
        &Play {
          width: 28.4rem;
          height: 16rem;
          margin-top: 1.25rem;
        }
      }
    }
    &Btn {
      margin-top: 6rem;
      margin-bottom: 3.75rem;
      margin-left: auto;
      margin-right: auto;
      min-width: 18.75rem;
      height: 3.75rem;
      background: linear-gradient(-90deg, #5a2cf0, #0066ff);
      font-size: 1.25rem;
      font-family: MicrosoftYaHei;
      font-weight: bold;
      color: #ffffff;
    }
  }
  &Join {
    margin-bottom: 1.875rem;
    &B {
      font-family: MicrosoftYaHei;
      font-weight: 300;
      color: #0d0d0d;
      font-size: 1.5rem;
    }

    &R {
      font-weight: 300;
      font-size: 1.5rem;
      font-weight: 700;
      color: #d9150b;
    }
  }

  &GridItem {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: start;
    &Img {
      width: 12.5vw;
      display: block; /* ★★★★★ */
      // max-width: 100%;
      height: 7vw;
      background: #d9d9d9;
      object-fit: fill;
    }
    &T {
      width: 12.5vw;
      margin-top: 1.125rem;
      font-size: 1rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #0d0d0d;
      min-height: 2rem;
      overflow-x: hidden;
      // line-height: 1.375rem;
    }
    &S {
      font-size: 0.875rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #737373;
      // line-height: 1.375rem;
    }
  }

  &GridItemH5 {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: start;
    &Img {
      width: 35vw;
      display: block; /* ★★★★★ */
      // max-width: 100%;
      height: 19.7vw;
      background: #d9d9d9;
      object-fit: fill;
    }
    &T {
      width: 35vw;
      margin-top: 1.125rem;
      font-size: 1rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #0d0d0d;
      min-height: 2rem;
      overflow-x: hidden;
      // line-height: 1.375rem;
    }
    &S {
      font-size: 0.875rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #737373;
      // line-height: 1.375rem;
    }
  }
  &Btn {
    min-height: 2.5rem;
    background: #ffffff;
    border: 0.0625rem solid #434343;
    border-radius: 0.125rem;
    font-size: 1.125rem;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    padding-left: 4rem;
    padding-right: 4rem;
    color: #0d0d0d;
    margin-bottom: 7.5rem;
  }
}
</style>
